<div class="container-fluid">
    <app-pagetitle title="Assign Diagnostic Tests" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
</div>
<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <button type="button" class="btn btn-success" (click)="gotoassigntest()">
                    <i class=" ri-menu-2-fill align-middle me-2"></i>Assign Diagnostic Test
                </button>
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Patient Type<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <div>
                                    <select formControlName="patient_type" class="form-control"
                                        [ngClass]="{'is-invalid': typesubmit && type.patient_type.errors}">
                                        <option value="" selected>Select</option>
                                        <option value="OP">OP</option>
                                        <option value="Doctor">Doctor</option>
                                    </select>
                                    <div *ngIf="typesubmit && type.patient_type.errors" class="invalid-feedback">
                                        <span *ngIf="type.patient_type.errors.required">This value is required.</span>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label>UHID Number<span style="color: red;">*</span></label>
                                <ng-select (change)="onPatientIdChange($event,form)"
                                    [class.is-invalid]="typesubmit && type.patient_id.errors"
                                    formControlName="patient_id">
                                    <ng-option value="{{a.patient_id}}" *ngFor="let a of patientdata">{{a.patient_id}}-
                                        ( {{a.name}} {{a.last_name}} )
                                    </ng-option>
                                </ng-select>
                                <div *ngIf="typesubmit && type.patient_id.errors" class="invalid-feedback">
                                    <span *ngIf="type.patient_id.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Surname: <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="last_name" readonly />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Name: <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="name" readonly />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Age : <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="number" class="form-control" formControlName="age" readonly />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Gender : <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="gender" readonly />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Address : <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="address" readonly />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Payment Type<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <ng-select id="inputstate" id="default-select" formControlName="pymnt_type"
                                    (change)="selectfield($event)"
                                    [class.is-invalid]="typesubmit && type.pymnt_type.errors">
                                    <ng-option value="" selected>Select Payment Method</ng-option>
                                    <ng-option value="cash">Cash</ng-option>
                                    <ng-option value="upi">UPI</ng-option>
                                </ng-select>
                                <div *ngIf="typesubmit && type.pymnt_type.errors" class="invalid-feedback">
                                    <span *ngIf="type.pymnt_type.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4" *ngIf="upi">
                            <div class="form-group">
                                <label>Enter Transaction ID <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="upiId"
                                    placeholder="Enter Transaction ID" />

                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Discount % </label>
                                <ng-select id="inputstate" id="default-select" formControlName="discount">
                                    <ng-option value="" disabled Selected>Select the Option</ng-option>
                                    <ng-option value="0">0%</ng-option>
                                    <ng-option value="5">5%</ng-option>
                                    <ng-option value="10">10%</ng-option>
                                    <ng-option value="15">15%</ng-option>
                                    <ng-option value="20">20%</ng-option>
                                    <ng-option value="25">25%</ng-option>
                                    <ng-option value="30">30%</ng-option>
                                    <ng-option value="35">35%</ng-option>
                                    <ng-option value="40">40%</ng-option>
                                    <ng-option value="45">45%</ng-option>
                                    <ng-option value="50">50%</ng-option>
                                </ng-select>
                            </div>
                        </div>

                    </div>
                </form>


                <h5 class="mt-4">Add Diagnostic Test</h5>


                <form [formGroup]="myform">
                    <br>
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Diagnostic Test Name <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <ng-select (change)="onDiagnosticNameChange($event)" formControlName="diagnostic_name">
                                    <ng-option *ngFor="let v of diagnosticdata"
                                        [value]="{name:v.diagnostic_name, id:v.id}">{{v.diagnostic_name}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Diagnostic Test Amount<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="diagnostic_amount" readonly />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <br>
                            <button type="submit" class="btn btn-secondary me-1 mt-3" (click)="adddiagnostictest()"> Add
                                Test </button>
                        </div>

                        <div class="col-lg-8">
                            <br>
                            <div class="table-responsive" *ngIf="testlistArr.length">
                                <table class="table table-bordered mb-0 ">
                                    <thead>
                                        <tr style="background-color: #ccc; font-size: 17px;">
                                            <th style="width:50px">S.No</th>
                                            <th>Diagnostic Test Name</th>
                                            <th>Diagnostic Test Amount</th>
                                            <th>Action</th>
                                        </tr>
                                        <tr *ngFor="let i of testlistArr;let y = index">
                                            <th>{{y+1}}</th>
                                            <th>{{i.diagnostic_name}}</th>
                                            <th>{{i.diagnostic_amount}}</th>
                                            <th> <i style="font-size: 20px;border-radius:5px;background-color: rgb(33, 130, 44);color: white;padding: 4%;"
                                                    class="ri-delete-bin-line" (click)="deleteTest(y)"
                                                    title="Delete"></i></th>
                                        </tr>
                                        <tr style="background-color: #ccc;font-size: 17px;">
                                            <th></th>
                                            <th colspan="1">Total Price</th>
                                            <th colspan="1"> {{grandtotal}}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="form-group mb-0" style="text-align: right;">
                    <br>
                    <button type="submit" class="btn btn-primary me-1" (click)="typeSubmit()"> Submit </button>
                    <button type="reset" (click)="reset()" class="btn btn-secondary"> Reset </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title"></h4>
                <div class="table-responsive">
                    <table class="table table-bordered table-striped mb-0 table-striped">
                        <thead class="table-dark">
                            <tr>
                                <th>S.no</th>
                                <th>Print</th>
                                <th>Diagnostic Test Date</th>
                                <th>UHID</th>
                                <th>Name</th>
                                <th>Age</th>
                                <th>Address</th>
                                <th>Gender</th>
                                <th>Grand Total</th>
                                <th>Discount %</th>
                                <th>Discount Amount</th>
                                <th>Total After Discount</th>
                                <th>Payment Mode</th>
                                <th>Transaction ID</th>
                                <th>View </th>
                                <th>Action </th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let i of assigneddata;let y =index">
                                <td scope="row">{{y+1}}</td>
                                <td><i style="cursor: pointer;font-size: 20px;border-radius:5px;background-color: rgb(33, 130, 44);color: white;padding: 4%;"
                                    class="fa fa-print"></i></td>
                                <td style="min-width: 110px !important;">{{i.test_date| date:'dd-MM-yyyy'}}</td>
                                <td>{{i.patient_id}}</td>
                                <td>{{i.last_name}} {{i.name}}</td>
                                <td> {{i.age}}</td>
                                <td>{{i.address}}</td>
                                <td>{{i.gender}}</td>
                                <td>{{i.grandtotal}}</td>
                                <td>{{i.discount}}</td>
                                <td>{{ (i.discount / 100) * i.grandtotal | number: '1.2-2' }}</td>
                                <td>{{ i.grandtotal - (i.discount / 100) * i.grandtotal | number: '1.2-2' }}</td>
                                <td>{{i.pymnt_type}}</td>
                                <td>
                                    <span *ngIf="i.pymnt_type == 'upi'">{{i.upiId}}</span>
                                    <span *ngIf="i.pymnt_type == 'cash' || i.pymnt_type == 'other'"> - </span>
                                </td>
                                <td><i style="font-size: 20px;color: rgb(82, 79, 79);padding: 2%;text-align: center;"
                                        class="ri-eye-fill" title="View"
                                        (click)="gettestlist(i.id, centerDataModal1)"></i>
                                </td>

                                <td>
                                    <div style="display: flex;">

                                        <i style="font-size: 20px;border-radius:5px;background-color: rgb(31, 115, 31);color: white;padding: 2%;"
                                            class="ri-edit-fill" title="Edit"
                                            (click)="centerModal(centerDataModal,i)"></i>&nbsp;&nbsp;
                                        <i style="font-size: 20px;border-radius:5px;background-color: rgb(83, 12, 12);color: white;padding: 2%;"
                                            class="ri-delete-bin-2-line" title="Delete" (click)="Delete(i)"></i>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #centerDataModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">Edit Details </h5>
        <button type="button" class="btn-close" (click)="close23()" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <form (ngSubmit)="edit()" [formGroup]="editForm">
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Patient Type<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <div>
                            <select formControlName="patient_type" class="form-control">
                                <option value="" selected>Select</option>
                                <option value="OP">OP</option>
                                <option value="Doctor">Doctor</option>
                            </select>
                            <!-- <div *ngIf="typesubmit && type.patient_type.errors" class="invalid-feedback">
                                <span *ngIf="type.patient_type.errors.required">This value is required.</span>

                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <label>UHID Number<span style="color: red;">*</span></label>
                    <ng-select (change)="onPatientIdChange($event,editForm)" formControlName="patient_id">
                        <ng-option value="{{a.patient_id}}" *ngFor="let a of patientdata">{{a.patient_id}}</ng-option>
                    </ng-select>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Surname: <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="last_name" readonly />
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Name: <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="name" readonly />
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Age : <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="number" class="form-control" formControlName="age" readonly />
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Gender : <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="gender" readonly />
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Address : <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="address" readonly />
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Payment Type<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <ng-select id="inputstate" id="default-select" formControlName="pymnt_type"
                            (change)="selectfield($event)">
                            <ng-option value="" selected>Select Payment Method</ng-option>
                            <ng-option value="cash">Cash</ng-option>
                            <ng-option value="upi">UPI</ng-option>
                        </ng-select>
                        <!-- <div *ngIf="typesubmit && type.pymnt_type.errors" class="invalid-feedback">
                            <span *ngIf="type.pymnt_type.errors.required">This value is required.</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-lg-4" *ngIf="upi">
                    <div class="form-group">
                        <label>Enter Transaction ID </label>
                        <input type="text" class="form-control" formControlName="upiId"
                            placeholder="Enter Transaction ID" />

                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Discount % </label>
                        <ng-select id="inputstate" id="default-select" formControlName="discount">
                            <ng-option value="" disabled Selected>Select the Option</ng-option>
                            <ng-option value="0">0%</ng-option>
                            <ng-option value="5">5%</ng-option>
                            <ng-option value="10">10%</ng-option>
                            <ng-option value="15">15%</ng-option>
                            <ng-option value="20">20%</ng-option>
                            <ng-option value="25">25%</ng-option>
                            <ng-option value="30">30%</ng-option>
                            <ng-option value="35">35%</ng-option>
                            <ng-option value="40">40%</ng-option>
                            <ng-option value="45">45%</ng-option>
                            <ng-option value="50">50%</ng-option>
                        </ng-select>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary me-1"> Save changes </button>
                    <button type="reset" class="btn btn-secondary"> Reset</button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #centerDataModal1 let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">View Diagnostic Tests</h5>
        <button type="button" class="btn-close" (click)="close23()" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <div class="table-responsive m-2">
            <table class="table table-bordered mb-0">
                <thead>
                    <tr style="background-color:#ccc;font-size: 17px;">
                        <th style="width:50px">S.NO</th>
                        <th>Diagnostic Test Name</th>
                        <th>Diagnostic Test Amount</th>

                    </tr>
                    <tr *ngFor="let a of diagnostictest;let i =index;">
                        <td>{{i+1}}</td>
                        <th>{{a.diagnostic_name}}</th>
                        <th>{{a.diagnostic_amount}}</th>
                        <!-- <th> <i style="font-size: 20px;border-radius:5px;background-color: rgb(33, 130, 44);color: white;padding: 4%;"
                                class="ri-delete-bin-line" (click)="deleterow(i)" title="Delete"></i>
                        </th> -->
                    </tr>
                </thead>
            </table>
        </div>
    </div>
</ng-template>